import { Container } from "react-bootstrap";

function Titre({ interaction }) {
    return (
        <Container className="home-title">
            <h1 className="text-center">{interaction.title}</h1>
        </Container>
    )
}
export default Titre;